import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import { useLanguage } from '../i18n';

const EnvelopeOpening = ({ onOpen, onStartMusic }) => {
  const [isLeaving, setIsLeaving] = useState(false);
  const { t } = useLanguage();

  const handleEnter = () => {
    if (isLeaving) return;
    onStartMusic();
    setIsLeaving(true);
    setTimeout(() => onOpen(), 900);
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center overflow-hidden transition-opacity duration-700 ${
        isLeaving ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
      style={{
        background: 'linear-gradient(180deg, hsl(0 0% 100%) 0%, hsl(0 73% 97%) 45%, hsl(0 0% 100%) 100%)'
      }}
      data-testid="entrance-screen"
    >
      {/* Decorative background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-10 w-64 h-64 bg-lavender/8 rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-10 w-72 h-72 bg-blush/40 rounded-full blur-3xl" />
        <div className="absolute inset-0 damask-pattern opacity-50" />
      </div>

      <div className="relative text-center px-6 max-w-xl mx-auto">
        {/* Monogram */}
        <div className="mb-10 animate-fade-in">
          <div className="w-16 h-16 rounded-full border border-gold/40 flex items-center justify-center mx-auto bg-card/60">
            <Heart className="w-6 h-6 text-lavender" fill="currentColor" />
          </div>
        </div>

        {/* Invitation line */}
        <p className="font-display text-xs uppercase tracking-[0.5em] text-muted-foreground mb-8 animate-fade-in delay-100">
          {t('entrance.invited')}
        </p>

        {/* Names */}
        <h1 className="font-script text-6xl md:text-7xl text-lavender mb-6 animate-fade-in delay-200" data-testid="entrance-names">
          Jherli & Mirko
        </h1>

        {/* Divider */}
        <div className="flex items-center justify-center gap-4 mb-6 animate-fade-in delay-300">
          <span className="w-16 h-px bg-gradient-to-r from-transparent to-gold/50" />
          <span className="text-lavender/50">❦</span>
          <span className="w-16 h-px bg-gradient-to-l from-transparent to-gold/50" />
        </div>

        {/* Date */}
        <p className="font-display text-sm tracking-[0.4em] text-foreground mb-14 animate-fade-in delay-400">
          28 · 12 · 2026
        </p>

        {/* Enter button */}
        <button
          onClick={handleEnter}
          className="group relative inline-flex items-center gap-3 px-12 py-4 rounded-full border border-lavender/50 text-lavender overflow-hidden transition-colors duration-500 hover:text-white animate-fade-in delay-500"
          data-testid="open-invitation-button"
        >
          <span className="absolute inset-0 bg-lavender scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500 rounded-full" />
          <span className="relative font-display text-sm uppercase tracking-[0.3em]">{t('entrance.open')}</span>
        </button>
      </div>
    </div>
  );
};

export default EnvelopeOpening;
